import _objectSpread from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var _webSocketCommandPara;
import moment from 'moment/moment';
import { mssActionConstants } from '../../constants';
import { formatCreateFolderMssWs, formatDeleteFolderMssWs, formatDownloadAttachementFromMssWs, formatFullSearchMssMessages, formatFullSearchMssMessagesIMAP, formatGenerateMssAttachments, formatGetEmailAdressFromMssWs, formatGetFoldersFromMssWs, formatMoveMssMessages, formatRenameFolderMssWs, formatSearchMessagesFromMssWs, formatSendDocumentParams, formatSendMssEmail, formatSendMssWebEmail, formatSyncMessagesFromMssWs, formatUpdateMessagesFromMssWs } from './commandParamsFormatters';
import commands, { commandSubTypes, commandTypes, mssSubTypes } from './commands';
var webSocketCommandParams = (_webSocketCommandPara = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.activeFeatures, {
  type: commandTypes.WS,
  commandName: 'hl_activeFeatures'
}), commands.getTimeSynchronizationDifference, {
  type: commandTypes.WS,
  commandName: 'hl_getTimeSynchronizationDifference'
}), commands.openSession, {
  type: commandTypes.WS,
  commandName: 'hl_openSession'
}), commands.closeSession, {
  type: commandTypes.WS,
  commandName: 'hl_closeSession'
}), commands.getSessionState, {
  type: commandTypes.WS,
  commandName: 'hl_getSessionState'
}), commands.sessionExists, {
  type: commandTypes.WS,
  commandName: 'hl_sessionExists'
}), commands.updateCpxAuthenticationToken, {
  type: commandTypes.WS,
  commandName: 'hl_updateCpxAuthenticationToken'
}), commands.updateVitaleAuthenticationToken, {
  type: commandTypes.WS,
  commandName: 'hl_updateVitaleAuthenticationToken'
}), commands.getCpxCard, {
  type: commandTypes.WS,
  commandName: 'hl_getCpxCard',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getCpxStatus, {
  type: commandTypes.WS,
  commandName: 'hl_getCpxStatus',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.getCpxHpInfos, {
  type: commandTypes.WS,
  commandName: 'hl_getCpxHpInfos',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.readCpxCard, {
  type: commandTypes.WS,
  commandName: 'hl_readCpxCard',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.checkCpxTokenStatus, {
  type: commandTypes.WS,
  commandName: 'hl_checkCpxTokenStatus',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getVitaleCard, {
  type: commandTypes.WS,
  commandName: 'hl_getVitaleCard',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.readVitaleCard, {
  type: commandTypes.WS,
  commandName: 'hl_readVitaleCard',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getVitaleXmlContent, {
  type: commandTypes.WS,
  commandName: 'getObjectParameterString',
  paramsGetter: function paramsGetter(vitaleHandle) {
    return {
      i_parameter: 30,
      i_resultInBase64: 1,
      i_object: vitaleHandle
    };
  },
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getPcscReaders, {
  type: commandTypes.WS,
  commandName: 'hl_getPcscReaders',
  timeout: 180
}), commands.setPracticeLocation, {
  type: commandTypes.WS,
  commandName: 'hl_setPracticeLocation',
  paramsGetter: function paramsGetter(_ref) {
    var cpsPracticeLocationIndice = _ref.cpsPracticeLocationIndice,
      practiceSetting = _ref.practiceSetting;
    return {
      i_cpsPracticeLocationIndice: Number(cpsPracticeLocationIndice),
      s_practiceSetting: practiceSetting
    };
  },
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.createDMPConnector, {
  type: commandTypes.WS,
  commandName: 'hl_createDmpConnector',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.createTLSiConnector, {
  type: commandTypes.WS,
  commandName: 'hl_createTlsiConnector'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.createEsTLsiConnector, {
  type: commandTypes.WS,
  commandName: 'hl_createEsTlsiConnector'
}), commands.createDpConnector, {
  type: commandTypes.WS,
  commandName: 'hl_createDpConnector'
}), commands.createEsDMPConnector, {
  type: commandTypes.WS,
  commandName: 'hl_createEsDmpConnector',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.findPatient, {
  type: commandTypes.WS,
  commandName: 'hl_findPatients',
  timeout: 180,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getAccessibleDMPList, {
  type: commandTypes.WS,
  commandName: 'hl_getAccessibleDMPList',
  timeout: 600,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getDirectAuthenticationDMPStatus, {
  type: commandTypes.WS,
  commandName: 'hl_getDirectAuthenticationDMPStatus',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getDMPStatus, {
  type: commandTypes.WS,
  commandName: 'hl_getDMPStatus',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getCertifiedIdentity, {
  type: commandTypes.WS,
  commandName: 'hl_getCertifiedIdentity',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.findDocuments, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_findDocuments',
  timeout: 600,
  longRunningTimeout: 120,
  multipleCalls: false
}), commands.updateUserDmpAccessAuthorization, {
  type: commandTypes.WS,
  commandName: 'hl_updateUserDmpAccessAuthorization',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.updateDocumentVisibilityByUniqueId, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_updateDocumentVisibilityByUniqueId'
}), commands.setDMPAccessMode, {
  type: commandTypes.WS,
  commandName: 'hl_setDmpAccessMode'
}), commands.setConfidentialityLevel, {
  type: commandTypes.WS,
  commandName: 'hl_setConfidentialityLevel'
}), commands.getDmpAdministrativeData, {
  type: commandTypes.WS,
  commandName: 'hl_getDmpAdministrativeData',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getDocumentContentByUniqueId, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_getDocumentContentByUniqueId',
  timeout: 600
}), commands.getDocumentsContentByUniqueId, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_getDocumentsContentByUniqueId',
  timeout: 600
}), commands.deleteDocument, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_deleteDocument'
}), commands.deleteArchivedDocument, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_deleteArchivedDocument'
}), commands.updateDocumentStatusByUniqueId, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_updateDocumentStatusByUniqueId'
}), commands.validateDocuments, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_validateDocuments',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref2) {
    var ins = _ref2.ins,
      base64Content = _ref2.base64Content,
      title = _ref2.title,
      description = _ref2.description,
      category = _ref2.category,
      visibility = _ref2.visibility,
      format = _ref2.format,
      healthcareSetting = _ref2.healthcareSetting,
      creationDate = _ref2.creationDate,
      serviceStartDate = _ref2.serviceStartDate,
      serviceStopDate = _ref2.serviceStopDate,
      replacedDocumentId = _ref2.replacedDocumentId,
      Informants = _ref2.Informants,
      Performer = _ref2.Performer,
      TreatingPhycisian = _ref2.TreatingPhycisian,
      AdditionalAuthors = _ref2.AdditionalAuthors,
      IntendedRecipients = _ref2.IntendedRecipients,
      eventCodes = _ref2.eventCodes,
      retrieveDocumentUuid = _ref2.retrieveDocumentUuid,
      forceSchematronsValidation = _ref2.forceSchematronsValidation,
      ignorePdfA1Transparency = _ref2.ignorePdfA1Transparency,
      disabledPdfA1Conversion = _ref2.disabledPdfA1Conversion,
      versionNumber = _ref2.versionNumber,
      setIdRoot = _ref2.setIdRoot,
      setIdExtension = _ref2.setIdExtension,
      uniqueId = _ref2.uniqueId,
      Identity = _ref2.Identity,
      transcodeTypeCode = _ref2.transcodeTypeCode,
      getCdaHeaders = _ref2.getCdaHeaders,
      getContent = _ref2.getContent,
      getCdaContent = _ref2.getCdaContent,
      stylesheetBase64 = _ref2.stylesheetBase64,
      structuredBody = _ref2.structuredBody;
    return {
      Documents: [{
        s_oid: uniqueId,
        s_title: title,
        s_description: description,
        s_category: category,
        i_visibility: visibility,
        i_format: format,
        s_contentInBase64: base64Content,
        s_stylesheetInBase64: stylesheetBase64,
        s_creationDate: creationDate ? moment.utc(creationDate, ['DD/MM/YYYY']).local().format('YYYYMMDDHHmmssZZ') : undefined,
        s_serviceStartDate: serviceStartDate ? moment.utc(serviceStartDate, ['DD/MM/YYYY']).local().format('YYYYMMDDHHmmssZZ') : undefined,
        s_serviceStopDate: serviceStopDate ? moment.utc(serviceStopDate, ['DD/MM/YYYY']).local().format('YYYYMMDDHHmmssZZ') : undefined,
        s_replacedDocumentUniqueId: replacedDocumentId,
        EventCodes: (eventCodes || []).map(function (eventCode) {
          return {
            s_code: eventCode.code,
            s_classification: eventCode.classification,
            s_description: eventCode.description
          };
        }),
        TreatingPhysician: TreatingPhycisian,
        Performer: Performer,
        AdditionalAuthors: AdditionalAuthors,
        IntendedRecipients: IntendedRecipients,
        Informants: Informants,
        s_versionNumber: versionNumber,
        s_setIdRoot: setIdRoot,
        s_setIdExtension: setIdExtension,
        StructuredBody: structuredBody
      }],
      s_ins: ins,
      s_healthcareSetting: healthcareSetting,
      Identity: Identity,
      s_submissionSetTitle: title,
      i_transcodeTypeCode: Number(transcodeTypeCode),
      i_getCdaHeaders: Number(getCdaHeaders),
      i_getContent: Number(getContent),
      i_getCda: Number(getCdaContent),
      i_forceSchematronsValidation: forceSchematronsValidation === true ? 1 : 0,
      i_pdfa1IgnoreTransparency: ignorePdfA1Transparency === true ? 1 : 0,
      i_disablePdfa1Conversion: disabledPdfA1Conversion === true ? 1 : 0,
      i_retrieveDocumentUuid: retrieveDocumentUuid
    };
  }
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.sendDocument, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_sendDocument',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref3) {
    var ins = _ref3.ins,
      base64Content = _ref3.base64Content,
      title = _ref3.title,
      description = _ref3.description,
      category = _ref3.category,
      visibility = _ref3.visibility,
      format = _ref3.format,
      healthcareSetting = _ref3.healthcareSetting,
      creationDate = _ref3.creationDate,
      serviceStartDate = _ref3.serviceStartDate,
      serviceStopDate = _ref3.serviceStopDate,
      replacedDocumentId = _ref3.replacedDocumentId,
      Informants = _ref3.Informants,
      Performer = _ref3.Performer,
      TreatingPhycisian = _ref3.TreatingPhycisian,
      AdditionalAuthors = _ref3.AdditionalAuthors,
      IntendedRecipients = _ref3.IntendedRecipients,
      eventCodes = _ref3.eventCodes,
      retrieveDocumentUuid = _ref3.retrieveDocumentUuid,
      forceSchematronsValidation = _ref3.forceSchematronsValidation,
      ignorePdfA1Transparency = _ref3.ignorePdfA1Transparency,
      disabledPdfA1Conversion = _ref3.disabledPdfA1Conversion,
      versionNumber = _ref3.versionNumber,
      setIdRoot = _ref3.setIdRoot,
      setIdExtension = _ref3.setIdExtension,
      uniqueId = _ref3.uniqueId,
      Identity = _ref3.Identity,
      transcodeTypecode = _ref3.transcodeTypecode,
      stylesheetBase64 = _ref3.stylesheetBase64,
      AdditionalPatientIdentifiers = _ref3.AdditionalPatientIdentifiers,
      getDocumentContent = _ref3.getDocumentContent,
      structuredBody = _ref3.structuredBody;
    return formatSendDocumentParams(ins, base64Content, title, description, category, visibility, format, healthcareSetting, creationDate, replacedDocumentId, eventCodes, Informants, Performer, TreatingPhycisian, AdditionalAuthors, IntendedRecipients, retrieveDocumentUuid, serviceStartDate, serviceStopDate, forceSchematronsValidation, ignorePdfA1Transparency, disabledPdfA1Conversion, versionNumber, setIdRoot, setIdExtension, uniqueId, Identity, transcodeTypecode, stylesheetBase64, AdditionalPatientIdentifiers, getDocumentContent, structuredBody);
  }
}), commands.getSubmissionSetDocuments, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_getSubmissionSetDocuments'
}), commands.getDocumentSubmissionSetIdByUniqueId, {
  type: commandTypes.WS,
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true,
  commandName: 'hl_getDocumentSubmissionSetIdByUniqueId'
}), commands.createDMPAndOtp, {
  type: commandTypes.WS,
  commandName: 'hl_createDmpAndOtp',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.closeDMP, {
  type: commandTypes.WS,
  commandName: 'hl_closeDmp',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.reactivateDMP, {
  type: commandTypes.WS,
  commandName: 'hl_reactivateDmp',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.updateDmpAdministrativeData, {
  type: commandTypes.WS,
  commandName: 'hl_updateDmpAdministrativeData',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getPatientWebAccessPdf, {
  type: commandTypes.WS,
  commandName: 'hl_getPatientWebAccessPdf'
}), commands.createAcknowledgementPdf, {
  type: commandTypes.WS,
  commandName: 'hl_createAcknowledgementPdf'
}), commands.getDmpAuthorizationsList, {
  type: commandTypes.WS,
  commandName: 'hl_getDmpAuthorizationsList',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.setWebPsRootUrl, {
  type: commandTypes.WS,
  commandName: 'hl_setWebPsRootUrl',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getWebPsDmpUrls, {
  type: commandTypes.WS,
  commandName: 'hl_getWebPsDmpUrls',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getOtpChannelValue, {
  type: commandTypes.WS,
  commandName: 'hl_getOtpChannelValue'
}), commands.getInteropCodes, {
  type: commandTypes.WS,
  commandName: 'hl_getInteropCodes'
}), commands.getNosCodes, {
  type: commandTypes.WS,
  commandName: 'hl_getNosCodes'
}), commands.getCiSisCodes, {
  type: commandTypes.WS,
  commandName: 'hl_getCiSisCodes'
}), commands.getCisCodes, {
  type: commandTypes.WS,
  commandName: 'hl_getCisCodes'
}), commands.getAtcCodes, {
  type: commandTypes.WS,
  commandName: 'hl_getAtcCodes'
}), commands.getDmpParameters, {
  type: commandTypes.WS,
  commandName: 'hl_getDmpParameters'
}), commands.getInsNirFromInsC, {
  type: commandTypes.WS,
  commandName: 'hl_getInsNirFromInsC'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.getObjectParameterInt, {
  type: commandTypes.WS,
  commandName: 'getObjectParameterInt'
}), commands.clearPersistantData, {
  type: commandTypes.WS,
  commandName: 'hl_clearPersistantData'
}), commands.getPersistantData, {
  type: commandTypes.WS,
  commandName: 'hl_getPersistantData'
}), commands.setPersistantData, {
  type: commandTypes.WS,
  commandName: 'hl_setPersistantData'
}), commands.checkUserLicenseRight, {
  type: commandTypes.WS,
  commandName: 'hl_checkUserLicenseRight'
}), commands.isDcParamsRegistered, {
  type: commandTypes.HTTP,
  endpoint: '/remotecommand/isDcParameterRegistered',
  paramsGetter: function paramsGetter(dcParams) {
    return {
      s_dcparameters64: dcParams
    };
  }
}), commands.registerDcParams, {
  type: commandTypes.HTTP,
  endpoint: '/remotecommand/registerDcParameter',
  paramsGetter: function paramsGetter(dcParams) {
    return {
      s_dcparameters64: dcParams
    };
  }
}), commands.unregisterDcParams, {
  type: commandTypes.HTTP,
  endpoint: '/remotecommand/unregisterDcParameter',
  paramsGetter: function paramsGetter(dcParams) {
    return {
      s_dcparameters64: dcParams
    };
  }
}), commands.setVitaleXmlContent, {
  type: commandTypes.WS,
  commandName: 'hl_setVitaleXmlContent'
}), commands.getAldFromVitaleCard, {
  type: commandTypes.WS,
  commandName: 'hl_getAldFromVitaleCard',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.getInsFromVitaleCard, {
  type: commandTypes.WS,
  commandName: 'hl_getInsFromVitaleCard',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getInsFromIdentityInformation, {
  type: commandTypes.WS,
  commandName: 'hl_getInsFromIdentityInformation',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.checkIdentity, {
  type: commandTypes.WS,
  commandName: 'hl_checkInsIdentity',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.submitInsiBatchValidationSet, {
  type: commandTypes.WS,
  commandName: 'hl_submitInsiBatchValidationSet',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getInsiBatchValidationSetResult, {
  type: commandTypes.WS,
  commandName: 'hl_getInsiBatchValidationSetResult',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getMssHpInfos, {
  type: commandTypes.WS,
  commandName: 'hl_getMssHpInfos'
}), commands.performMssAuthentication, {
  type: commandTypes.WS,
  commandName: 'hl_performMssAuthentication'
}), commands.initiateMssOtpAuthentication, {
  type: commandTypes.WS,
  commandName: 'hl_initiateMssOtpAuthentication'
}), commands.finalizeMssOtpAuthentication, {
  type: commandTypes.WS,
  commandName: 'hl_finalizeMssOtpAuthentication'
}), commands.getEmailAdress, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  paramsGetter: function paramsGetter(rpps) {
    return formatGetEmailAdressFromMssWs(rpps);
  }
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.getFoldersMSS, _defineProperty(_defineProperty({
  subType: commandSubTypes.MSS
}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(email) {
    return formatGetFoldersFromMssWs(email);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapListFolders',
  timeout: 600,
  paramsGetter: function paramsGetter(email) {
    return {
      s_login: email
    };
  }
})), commands.createFolderMSS, _defineProperty(_defineProperty({
  subType: commandSubTypes.MSS
}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref4) {
    var email = _ref4.email,
      folderName = _ref4.folderName,
      folderParentId = _ref4.folderParentId;
    return formatCreateFolderMssWs(email, folderName, folderParentId);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapCreateFolder',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref5) {
    var email = _ref5.email,
      folderName = _ref5.folderName;
    return {
      s_login: email,
      s_folderName: folderName
    };
  }
})), commands.deleteFolderMSS, _defineProperty(_defineProperty({
  subType: commandSubTypes.MSS
}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref6) {
    var email = _ref6.email,
      folderId = _ref6.folderId;
    return formatDeleteFolderMssWs(email, folderId);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapDeleteFolder',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref7) {
    var email = _ref7.email,
      folderId = _ref7.folderId;
    return {
      s_login: email,
      s_folderName: folderId
    };
  }
})), commands.renameFolderMSS, _defineProperty(_defineProperty({
  subType: commandSubTypes.MSS
}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref8) {
    var email = _ref8.email,
      folderId = _ref8.folderId,
      newFolderName = _ref8.newFolderName;
    return formatRenameFolderMssWs(email, folderId, newFolderName);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapRenameFolder',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref9) {
    var email = _ref9.email,
      folderId = _ref9.folderId,
      newFolderName = _ref9.newFolderName;
    return {
      s_login: email,
      s_oldFolderName: folderId,
      s_newFolderName: newFolderName
    };
  }
})), commands.getSearchMessagesMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref10) {
    var email = _ref10.email,
      folderId = _ref10.folderId,
      offset = _ref10.offset,
      limit = _ref10.limit;
    return formatSearchMessagesFromMssWs(email, folderId, offset, limit);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapListMessages',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref11) {
    var email = _ref11.email,
      folderId = _ref11.folderId;
    return {
      s_login: email,
      s_folderName: folderId
    };
  }
})), commands.getMessageContentMss, _defineProperty({}, mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapGetMessage',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref12) {
    var email = _ref12.email,
      folderId = _ref12.folderId,
      messageId = _ref12.messageId;
    return {
      s_login: email,
      s_folderName: folderId,
      s_uid: messageId
    };
  }
})), commands.getSyncMessagesMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref13) {
    var email = _ref13.email,
      folderId = _ref13.folderId,
      token = _ref13.token;
    return formatSyncMessagesFromMssWs(email, folderId, token);
  }
}), mssSubTypes.IMAP, {
  forwardTo: mssActionConstants.IMAP_SYNC_MESSAGES
})), commands.updateMessagesMSS, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  paramsGetter: function paramsGetter(_ref14) {
    var email = _ref14.email,
      messageIds = _ref14.messageIds,
      operation = _ref14.operation;
    return formatUpdateMessagesFromMssWs(email, messageIds, operation);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapUpdateMessageFlags',
  paramsGetter: function paramsGetter(_ref15) {
    var email = _ref15.email,
      messageIds = _ref15.messageIds,
      operation = _ref15.operation,
      folderId = _ref15.folderId,
      add = _ref15.add;
    return {
      s_login: email,
      s_uid: messageIds[0],
      s_folderName: folderId,
      i_mode: add ? 1 : 2,
      Flags: [operation === 'READ' ? '\\Seen' : '']
    };
  }
})), commands.deleteMssMessages, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  paramsGetter: function paramsGetter(_ref16) {
    var email = _ref16.email,
      messageIds = _ref16.messageIds;
    return formatUpdateMessagesFromMssWs(email, messageIds, 'DELETE');
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapDeleteMessage',
  paramsGetter: function paramsGetter(_ref17) {
    var email = _ref17.email,
      messageIds = _ref17.messageIds,
      folderId = _ref17.folderId;
    return {
      s_login: email,
      s_uid: messageIds[0],
      s_folderName: folderId
    };
  }
})), commands.moveMSSMessages, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  paramsGetter: function paramsGetter(_ref18) {
    var email = _ref18.email,
      messageIds = _ref18.messageIds,
      destinationFolderId = _ref18.destinationFolderId;
    return formatMoveMssMessages(email, messageIds, destinationFolderId);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapMoveMessage',
  paramsGetter: function paramsGetter(_ref19) {
    var email = _ref19.email,
      messageIds = _ref19.messageIds,
      destinationFolderId = _ref19.destinationFolderId,
      sourceFolderId = _ref19.sourceFolderId;
    return {
      s_login: email,
      s_uid: messageIds[0],
      s_sourceFolderName: sourceFolderId,
      s_destinationFolderName: destinationFolderId
    };
  }
})), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.fullSearchMssMessages, _defineProperty(_defineProperty({}, mssSubTypes.WEB, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref20) {
    var email = _ref20.email,
      folderId = _ref20.folderId,
      from = _ref20.from,
      to = _ref20.to,
      subject = _ref20.subject,
      body = _ref20.body,
      dateFrom = _ref20.dateFrom,
      dateTo = _ref20.dateTo,
      hasAttachment = _ref20.hasAttachment;
    return formatFullSearchMssMessages(email, folderId, from, to, subject, body, dateFrom, dateTo, hasAttachment);
  }
}), mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapSearchMessages',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref21) {
    var email = _ref21.email,
      folderId = _ref21.folderId,
      from = _ref21.from,
      to = _ref21.to,
      subject = _ref21.subject,
      body = _ref21.body,
      dateFrom = _ref21.dateFrom,
      dateTo = _ref21.dateTo,
      hasAttachment = _ref21.hasAttachment;
    return formatFullSearchMssMessagesIMAP(email, folderId, from, to, subject, body, dateFrom, dateTo, hasAttachment);
  }
})), commands.getDownloadAttachmentMSS, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref22) {
    var email = _ref22.email,
      messageId = _ref22.messageId,
      part = _ref22.part;
    return formatDownloadAttachementFromMssWs(email, messageId, part);
  }
}), commands.sendMssSmtpEmail, {
  type: commandTypes.WS,
  commandName: 'hl_sendMssSmtpEmail',
  timeout: 600,
  subType: commandSubTypes.MSS_SMTP
}), commands.sendMssWebEmailSoap, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  paramsGetter: function paramsGetter(emailContent) {
    return formatSendMssWebEmail(emailContent);
  },
  timeout: 600
}), commands.sendMssWebEmailConnector, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssEmail',
  paramsGetter: function paramsGetter(emailContent) {
    return formatSendMssEmail(emailContent);
  },
  timeout: 600
}), commands.generateMssAttachments, {
  type: commandTypes.WS,
  commandName: 'hl_generateMssAttachments',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref23) {
    var attachments = _ref23.attachments,
      Identity = _ref23.Identity,
      insIsNotQualified = _ref23.insIsNotQualified,
      AdditionalPatientIdentifiers = _ref23.AdditionalPatientIdentifiers,
      disableIheXdmPdfTitlePage = _ref23.disableIheXdmPdfTitlePage,
      disableIheXdmPdfDataMatrixBlock = _ref23.disableIheXdmPdfDataMatrixBlock;
    return _objectSpread({}, formatGenerateMssAttachments(attachments), {
      Identity: Identity,
      i_insIsNotQualified: insIsNotQualified,
      AdditionalPatientIdentifiers: AdditionalPatientIdentifiers,
      i_disableIheXdmPdfTitlePage: disableIheXdmPdfTitlePage,
      i_disableIheXdmPdfDataMatrixBlock: disableIheXdmPdfDataMatrixBlock
    });
  }
}), commands.sendMssRequest, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_WS,
  commandName: 'hl_sendMssRequest',
  timeout: 600
}), commands.getDocumentsFromIheXdm, {
  type: commandTypes.WS,
  commandName: 'hl_getDocumentsFromIheXdm',
  timeout: 600,
  paramsGetter: function paramsGetter(iheXdmContentArchiveInBase64) {
    return {
      s_iheXdmContentArchiveInBase64: iheXdmContentArchiveInBase64
    };
  }
}), commands.imapAppendMessage, _defineProperty({}, mssSubTypes.IMAP, {
  type: commandTypes.WS,
  subType: commandSubTypes.MSS_IMAP,
  commandName: 'hl_imapAppendMessage',
  timeout: 600,
  paramsGetter: function paramsGetter(_ref24) {
    var email = _ref24.email,
      folderName = _ref24.folderName,
      messageInBase64 = _ref24.messageInBase64;
    return {
      s_login: email,
      s_folderName: folderName,
      s_messageInBase64: messageInBase64
    };
  }
})), commands.setMssEsImapCertificate, {
  type: commandTypes.WS,
  commandName: 'hl_setMssEsImapCertificate',
  paramsGetter: function paramsGetter(certificate) {
    return {
      s_certificateInBase64: certificate
    };
  }
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.setMssEsSmtpCertificate, {
  type: commandTypes.WS,
  commandName: 'hl_setMssEsSmtpCertificate',
  paramsGetter: function paramsGetter(certificate) {
    return {
      s_certificateInBase64: certificate
    };
  }
}), commands.setMssEsWebServiceCertificate, {
  type: commandTypes.WS,
  commandName: 'hl_setMssEsWebServiceCertificate',
  paramsGetter: function paramsGetter(certificate) {
    return {
      s_certificateInBase64: certificate
    };
  }
}), commands.getEsInfos, {
  type: commandTypes.WS,
  commandName: 'hl_getEsInfos'
}), commands.getUserInfos, {
  type: commandTypes.WS,
  commandName: 'hl_getUserInfos'
}), commands.getDp, {
  type: commandTypes.WS,
  commandName: 'hl_sendDpRequest'
}), commands.getNdp, {
  type: commandTypes.WS,
  commandName: 'hl_getNdp'
}), commands.dpGetMedicationDispensations, {
  type: commandTypes.WS,
  subType: commandSubTypes.DP,
  commandName: 'hl_dpGetMedicationDispensations'
}), commands.dpAddMedicationDispensations, {
  type: commandTypes.WS,
  subType: commandSubTypes.DP,
  commandName: 'hl_dpAddMedicationDispensations'
}), commands.dpDirectory_SearchRecord, {
  type: commandTypes.WS,
  subType: commandSubTypes.DP,
  commandName: 'hl_dpDirectory_SearchRecord'
}), commands.dpDirectory_GetRecordStatus, {
  type: commandTypes.WS,
  subType: commandSubTypes.DP,
  commandName: 'hl_dpDirectory_GetRecordStatus'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.dpDirectory_AddOrUpdateRecord, {
  type: commandTypes.WS,
  subType: commandSubTypes.DP,
  commandName: 'hl_dpDirectory_AddOrUpdateRecord'
}), commands.dpDirectory_DeleteRecord, {
  type: commandTypes.WS,
  subType: commandSubTypes.DP,
  commandName: 'hl_dpDirectory_DeleteRecord'
}), commands.createApCVConnector, {
  type: commandTypes.WS,
  commandName: 'hl_createApcvConnector',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getNfcCard, {
  type: commandTypes.WS,
  commandName: 'hl_getNfcCard'
}), commands.getNfcApCvUserData, {
  type: commandTypes.WS,
  commandName: 'hl_getNfcApCvUserData'
}), commands.getApCvContext, {
  type: commandTypes.WS,
  commandName: 'hl_getApCvContext',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.releaseApCvContext, {
  type: commandTypes.WS,
  commandName: 'hl_releaseApCvContext',
  olaqinJsRestSynchrone: true,
  validateolaqinPscToken: true
}), commands.getLogLevels, {
  type: commandTypes.WS,
  commandName: 'getLogLevels'
}), commands.setLogLevels, {
  type: commandTypes.WS,
  commandName: 'setLogLevels',
  paramsGetter: function paramsGetter(_ref25) {
    var dmpConnectLogLevel = _ref25.dmpConnectLogLevel,
      dmpConnectJsLogLevel = _ref25.dmpConnectJsLogLevel;
    return {
      i_dmpConnectLogLevel: Number(dmpConnectLogLevel),
      i_dmpConnectJsLogLevel: Number(dmpConnectJsLogLevel)
    };
  }
}), commands.getLogsTail, {
  type: commandTypes.WS,
  commandName: 'getLogsTail',
  paramsGetter: function paramsGetter(_ref26) {
    var getServerLog = _ref26.getServerLog,
      getDmpConnectLog = _ref26.getDmpConnectLog,
      nbServerLines = _ref26.nbServerLines,
      nbDmpConnectLines = _ref26.nbDmpConnectLines;
    return {
      i_getServerLog: Number(getServerLog),
      i_getDmpConnectLog: Number(getDmpConnectLog),
      i_serverLogNbLastLines: Number(nbServerLines),
      i_dmpConnectLogNbLastLines: Number(nbDmpConnectLines)
    };
  },
  timeout: 600
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_webSocketCommandPara, commands.getSessionLogsTail, {
  type: commandTypes.WS,
  commandName: 'hl_getSessionLogsTail',
  paramsGetter: function paramsGetter(_ref27) {
    var getServerLog = _ref27.getServerLog,
      getDmpConnectLog = _ref27.getDmpConnectLog,
      nbServerLines = _ref27.nbServerLines,
      nbDmpConnectLines = _ref27.nbDmpConnectLines;
    return {
      i_getServerLog: Number(getServerLog),
      i_getDmpConnectLog: Number(getDmpConnectLog),
      i_serverLogNbLastLines: Number(nbServerLines),
      i_dmpConnectLogNbLastLines: Number(nbDmpConnectLines)
    };
  },
  timeout: 600
}), commands.getSystemInformation, {
  type: commandTypes.WS,
  commandName: 'hl_getSystemInformation',
  timeout: 600
}), commands.searchLocalHealthDirectoryByRpps, {
  type: commandTypes.WS,
  commandName: 'hl_searchLocalHealthDirectory',
  paramsGetter: function paramsGetter(rpps) {
    return {
      Query: {
        s_type: 'EQUAL',
        s_attributeName: 'ident_nat_pp',
        s_attributeValue: rpps
      }
    };
  },
  timeout: 600
}), commands.searchFhirHealthDirectory, {
  type: commandTypes.WS,
  commandName: 'hl_searchFhirHealthDirectory',
  timeout: 600
}), commands.searchFhirAllHpOfStructure, {
  type: commandTypes.WS,
  commandName: 'hl_searchFhirAllHpOfStructure',
  timeout: 600
}), commands.pscAuthenticateUserCiba, {
  type: commandTypes.WS,
  commandName: 'hl_pscAuthenticateUserCiba',
  timeout: 600
}));
export default webSocketCommandParams;